import { useEffect, useState } from "react";
import { Button, Group, Modal, Paper, Text } from "@mantine/core";
import { ResourceForm, useMedplum } from "@medplum/react"
import { normalizeErrorString } from "@medplum/core";
import { useNavigate, useParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import PatientTabs from "./Tabs";

export function EditPatient() {
    const medplum = useMedplum()
    const { patientId } = useParams();
    const navigate = useNavigate();
    const [patientDetails, setPatientDetails] = useState<any>({});
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

    useEffect(() => {
        getPatientDetails()
    }, [medplum])

    const getPatientDetails = () => {
        medplum.readResource("Patient", `${patientId}`)
            .then((res: any) => {
                setPatientDetails(res)
            })
    };

    const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if ((res?.use === "official" || res?.use === "usual") && name === "--") {
          name = res?.text || res?.given[0];
        } 
      });
      if (name === "--") name = patientData[0]?.text || patientData[0]?.given || "--"
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  }

    const onSubmit = (clientData: any) => {
        medplum
            .updateResource(clientData)
            .then((res) => {
                showNotification({ color: "green", message: "Success" });

            })
            .catch((err) => {
                showNotification({
                    color: "red",
                    message: normalizeErrorString(err),
                    autoClose: false,
                });
            });
    }

    const deletePatient = () => {
        medplum
            .deleteResource("Patient", `${patientId}`)
            .then((res) => {
                navigate("/Patient");
            })
            .catch((err) => {
                showNotification({
                    color: "red",
                    message: normalizeErrorString(err),
                    autoClose: false,
                });
            });
    };

    return (
        <>
            <Modal
                opened={showDeleteConfirmModal}
                onClose={() => {
                    setShowDeleteConfirmModal(false);
                }}
                title="Delete Client"
            >
                <Text size="sm">
                    Are you sure you want to delete this Patient?
                </Text>
                <Group position="right" mt="lg">
                    <Button
                        type="submit"
                        size="sm"
                        onClick={() => setShowDeleteConfirmModal(false)}
                    >
                        No
                    </Button>
                    <Button type="button" color="red" size="sm" onClick={deletePatient}>
                        Delete
                    </Button>
                </Group>
            </Modal>
            <PatientTabs
                currentTab={"Edit"}
                patientName={getPatientName(patientDetails?.name)}
                patient={patientDetails}
            />
            <Paper
                sx={{
                    padding: "30px",
                    borderRadius: "8px",
                    margin: "40px",
                    background: "'#FFF",
                    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
                }}
            >
                <ResourceForm
                    defaultValue={patientDetails}
                    onSubmit={(formData: any) => onSubmit(formData)}
                    onDelete={() => setShowDeleteConfirmModal(true)}
                />
            </Paper>
        </>
    )
}